import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './HRAssistantOutputsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function HRAssistantOutputsSubTab() {
  const [outputs, setOutputs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ 
    telegram_id: '', 
    message_text: '', 
    response_text: '' 
  });

  useEffect(() => {
    fetchOutputs();
  }, []);

  const fetchOutputs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/hr-assistant-outputs`);
      setOutputs(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке ответов HR-ассистента: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/api/hr-assistant-outputs`, {
        telegram_id: parseInt(formData.telegram_id),
        message_text: formData.message_text,
        response_text: formData.response_text
      });
      setShowForm(false);
      setFormData({ telegram_id: '', message_text: '', response_text: '' });
      fetchOutputs();
    } catch (err) {
      setError('Ошибка при сохранении ответа HR-ассистента: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту запись?')) {
      try {
        await axios.delete(`${API_URL}/api/hr-assistant-outputs/${id}`);
        fetchOutputs();
      } catch (err) {
        setError('Ошибка при удалении записи: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setFormData({ telegram_id: '', message_text: '', response_text: '' });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="hr-assistant-outputs-sub-tab">
      <div className="tab-header">
        <h2>Ответы на сообщения</h2>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить запись
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h3>Добавить новую запись</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="telegram_id">Telegram ID пользователя *</label>
              <input
                type="number"
                id="telegram_id"
                value={formData.telegram_id}
                onChange={(e) => setFormData({ ...formData, telegram_id: e.target.value })}
                required
                min="1"
                placeholder="Введите Telegram ID"
              />
            </div>
            <div className="form-group">
              <label htmlFor="message_text">Текст сообщения *</label>
              <textarea
                id="message_text"
                value={formData.message_text}
                onChange={(e) => setFormData({ ...formData, message_text: e.target.value })}
                required
                rows="4"
                placeholder="Введите текст сообщения пользователя"
              />
            </div>
            <div className="form-group">
              <label htmlFor="response_text">Текст ответа *</label>
              <textarea
                id="response_text"
                value={formData.response_text}
                onChange={(e) => setFormData({ ...formData, response_text: e.target.value })}
                required
                rows="4"
                placeholder="Введите текст ответа на сообщение"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                Создать
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Telegram ID</th>
              <th>Текст сообщения</th>
              <th>Текст ответа</th>
              <th>Дата создания</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {outputs.length === 0 ? (
              <tr>
                <td colSpan="6" className="empty-state">
                  Нет записей. Добавьте первую запись.
                </td>
              </tr>
            ) : (
              outputs.map((output) => (
                <tr key={output.id}>
                  <td>{output.id}</td>
                  <td>{output.telegram_id}</td>
                  <td className="text-cell">
                    <div className="text-preview">
                      {output.message_text.length > 100 
                        ? output.message_text.substring(0, 100) + '...' 
                        : output.message_text}
                    </div>
                  </td>
                  <td className="text-cell">
                    <div className="text-preview">
                      {output.response_text.length > 100 
                        ? output.response_text.substring(0, 100) + '...' 
                        : output.response_text}
                    </div>
                  </td>
                  <td>{formatDate(output.created_at)}</td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(output.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default HRAssistantOutputsSubTab;
